import TheGrid from '@/views/scorecard/independents/objectives/grid'
import Edit from '@/views/scorecard/independents/objectives/edit'
import Importer from '@/views/scorecard/independents/objectives/import'

export default {
  path: '/scorecard-independents/objectives',
  redirect: '/scorecard-independents/objectives/index',
  name: 'independentObjectives',
  meta: {
    auth: {
      redirect: {
        name: 'independentObjectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Scorecard Independentes'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'independentObjectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'independentObjectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'independentObjectives.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'independentObjectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
